module.exports = __webpack_public_path__ + "img/prev.3707e0fc.svg";